export const SET_SPV_REQUESTS = (state, payload) => {
    state.spvRequests = payload;
};
export const SET_SPV_INFO = (state, payload) => {
    state.spvInfo = payload;
};
export const SET_SPVS = (state, payload) => {
    state.spvs = payload;
};